import { render, staticRenderFns } from "./BadOrder.vue?vue&type=template&id=4d90da17&scoped=true"
import script from "./BadOrder.vue?vue&type=script&lang=js"
export * from "./BadOrder.vue?vue&type=script&lang=js"
import style0 from "./BadOrder.vue?vue&type=style&index=0&id=4d90da17&prod&lang=less&scoped=true"
import style1 from "./BadOrder.vue?vue&type=style&index=1&id=4d90da17&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d90da17",
  null
  
)

export default component.exports